import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';


@Injectable({
    providedIn: 'root'
})

export class AgilityContentService {

    contentModelID: number = 0;
    bearerToken: string = '';

    contentModel: any = undefined;
    contentUrl: string = '';

    middleTierUrl: string = '';

    constructor(
        private http: HttpClient,

    ) { 
        this.bearerToken = environment.ConnectionInfo.middleTierBearer;
        this.contentModelID = environment.CompanyInfo.AgilityContentModel;
        this.middleTierUrl = environment.ConnectionInfo.middleTierUrl;
    }


    async getContentModel() {       
        const headers = new HttpHeaders({
            'Authorization': 'Bearer ' + this.bearerToken
        });

        console.log("initializing agility objects signal");

        let items = this.http.get<any>(this.middleTierUrl + 'api/Agility/GetItem?contentModel=' + this.contentModelID, { headers }).pipe(
            tap( response => {
                if(response != null ){ //&& response.responseCode === "200" //guesswork workaround for now
                    // console.log("Content Models: ", response);
                    return response;
                }else if(response.responseCode === "404"){
                    console.log("Content Model not found", response);
                }else if(response.responseCode === "500"){
                    console.log("ContentModel Server Error: ", response);
                }else{
                    console.log("ContentModel Unknown error: ", response); //why is it showing up here?
                }
            }, error=>{
                console.log("ContentModel Error: ", error);
            })
        );
        return items;
    }

    async resetContentModel(){
        const headers = new HttpHeaders({
            'Authorization': 'Bearer ' + this.bearerToken
        });
        console.log(">resetting content model<");
        this.http.get<any>(this.middleTierUrl + 'api/Agility/ResetItemCache?contentModel=' + this.contentModelID, { headers })
    }


}